import {PatchUserData} from "../interfaces";

export class UserPatchModel implements PatchUserData {
  name?: {
    last?: string;
    first?: string;
    middle?: string;
  };
  birth_date?: string;
  territory?: {
    okato?: string;
  };

  constructor(formData: any) {

    if (formData.fullName) {
      this.name = {};
      if (formData.fullName.lastName) {
        this.name.last = formData.fullName.lastName;
      }
      if (formData.fullName.firstName) {
        this.name.first = formData.fullName.firstName;
      }
      if (formData.fullName.middleName) {
        this.name.middle = formData.fullName.middleName;
      }
    }

    if (formData.birth_date) {
      const [day, month, year] = formData.birth_date.split('.');
      this.birth_date = `${year}-${month}-${day}`;
    }

    if (formData.region) {
      this.territory = {
        okato: formData.region.okato
      };
    }
  }
}
